{
  "language.label": "Language",
  "language.english": "English",
  "language.english.full": "English",
  "language.french": "French",
  "language.french.full": "French (Français)",
  "language.dutch": "Dutch",
  "language.dutch.full": "Dutch (Nederlands)",
  "logo.alt": "Flourish logo",
  "brand.tagline": "Champagne Region",
  "brand.taglineFooter": "Champagne Region",
  "nav.tourism": "Tourism",
  "nav.route": "Route touristique",
  "nav.community": "Community",
  "nav.wineries": "Champagne houses",
  "nav.download": "Download",
  "nav.partner": "Partner with us",
  "nav.downloadCta": "Download the app",
  "partnerModal.eyebrow": "Partner registration",
  "partnerModal.title": "Are you a champagne house?",
  "partnerModal.body": "This portal is reserved for champagne houses that want to register and appear in Flourish. Please confirm before continuing.",
  "partnerModal.confirm": "Yes, continue to registration",
  "partnerModal.cancel": "No, I am here to explore",
  "partnerModal.close": "Close dialog",
  "hero.eyebrow": "The perfect app to discover champagne",
  "hero.title": "Discover the Champagne region with Flourish.",
  "hero.body": "Flourish is your elegant travel companion as you journey through Champagne. Follow the Route Touristique, discover new places, and turn every stop into a living story with local reviews and friends' experiences.",
  "hero.highlight.reviews.title": "Reviews per location",
  "hero.highlight.reviews.body": "Taste notes, ambiance, and insider tips at every stop.",
  "hero.highlight.friends.title": "Follow your friends",
  "hero.highlight.friends.body": "See their routes, favorites, and the reviews they shared.",
  "hero.appStoreAlt": "Download on the App Store",
  "hero.playStoreAlt": "Get it on Google Play",
  "home.dashboard.hero.eyebrow": "Flourish is available on web and mobile",
  "home.dashboard.hero.title": "Plan, discover, and experience Champagne.",
  "home.dashboard.hero.body": "Browse Champagne houses and their wine selections, discover landmarks like museums, historical sites, viewpoints, and attractions, and follow official Route Touristique loops to plan your next visit from one place.",
  "home.dashboard.hero.primaryCta": "Open the web map",
  "home.dashboard.hero.secondaryCta": "Get the mobile app",
  "home.dashboard.hero.loginCta": "Log in to sync",
  "home.dashboard.hero.stepsTitle": "The platform's 3 advantages",
  "home.dashboard.hero.steps.one.title": "Meet the Champagne houses",
  "home.dashboard.hero.steps.one.body": "Discover their history, how they craft Champagne, and signature cuvées.",
  "home.dashboard.hero.steps.two.title": "A wide range of locations",
  "home.dashboard.hero.steps.two.body": "Museums, viewpoints, landmarks, and more.",
  "home.dashboard.hero.steps.three.title": "Read real experiences",
  "home.dashboard.hero.steps.three.body": "See what other visitors loved at each house.",
  "home.dashboard.overview.eyebrow": "At a glance",
  "home.dashboard.overview.title": "Your Champagne dashboard",
  "home.dashboard.stats.comingSoon": "Coming soon",
  "home.dashboard.stats.loginRequired": "Log in to sync",
  "home.dashboard.explore.eyebrow": "Discover now",
  "home.dashboard.explore.title": "Fresh picks across Champagne",
  "home.dashboard.explore.body": "A rotating mix of Champagne houses and landmarks to inspire your next stop.",
  "home.dashboard.explore.openMap": "Discover more places",
  "home.dashboard.explore.empty": "We're curating this section. Check back soon.",
  "home.dashboard.routes.title": "Touristic routes",
  "home.dashboard.routes.body": "Six official Route Touristique loops are available in the web map.",
  "home.dashboard.activity.title": "Community activity",
  "home.dashboard.activity.body": "See the latest tastings and visits from your network.",
  "home.dashboard.activity.empty": "No recent activity to display yet.",
  "home.dashboard.activity.more": "Open activity",
  "home.dashboard.activity.loginTitle": "Log in to view activity",
  "home.dashboard.activity.loginBody": "Sign in to see tastings and visits from you and your friends.",
  "home.dashboard.activity.loginCta": "Go to login",
  "home.dashboard.mobile.eyebrow": "Mobile companion",
  "home.dashboard.mobile.title": "Take Flourish on the road",
  "home.dashboard.mobile.body": "Use web to plan, then continue in the app while you travel through Champagne.",
  "route.eyebrow": "Route touristique",
  "route.title": "Plan a day tailored to you, without the crowds.",
  "route.body": "Flourish connects villages, viewpoints, and tastings into one seamless route. Follow the classic route or map your own around your favorite places.",
  "route.cards.one.title": "Start with a signature trail",
  "route.cards.one.body": "Choose a ready-made Route Touristique or build your own plan around your favorite locations.",
  "route.cards.two.title": "Discover hidden gems",
  "route.cards.two.body": "Discover new viewpoints, attractions, and local addresses.",
  "route.cards.three.title": "Make the day social",
  "route.cards.three.body": "Invite friends, compare notes, and save each other's favorite stops.",
  "community.eyebrow": "Community reviews",
  "community.title": "Every stop has a story to share.",
  "community.body": "Reviews show you what to expect there. Follow your friends to discover their favorite places and recommendations.",
  "community.reviews.one.name": "Camille R.",
  "community.reviews.one.body": "\"Arrived just before sunset. The tasting room was intimate, and the rose flight was unforgettable.\"",
  "community.reviews.one.location": "Verzenay - Grand Cru stop",
  "community.reviews.two.name": "Lucas M.",
  "community.reviews.two.body": "\"The cellar tour was full of detail. Loved the pairing notes shared by locals in the app.\"",
  "community.reviews.two.location": "Hautvillers - Heritage lane",
  "community.reviews.three.name": "Jules + Nora",
  "community.reviews.three.body": "\"We followed our friends' loop, added a picnic stop, and made it back with time for a golden-hour toast.\"",
  "community.reviews.three.location": "Cote des Blancs",
  "wineries.tag": "Available soon",
  "wineries.title": "Discover exceptional Champagne houses",
  "wineries.body": "We carefully select Champagne houses with tastings and unique wines for you.",
  "wineries.cards.one.title": "Contact the house",
  "wineries.cards.one.body": "Reach out directly to ask about visits, availability, and experiences.",
  "wineries.cards.two.title": "House signatures",
  "wineries.cards.two.body": "Discover exceptional cuvee releases and the stories behind each cellar.",
  "wineries.cards.three.title": "Collector selections",
  "wineries.cards.three.body": "Keep track of your favorite bottles in the app and share your experiences with friends.",
  "download.eyebrow": "Available now",
  "download.title": "Download Flourish and start your Champagne tour.",
  "download.body": "Find the app in the App Store or Google Play and start collecting routes, reviews, and recommendations.",
  "download.qrLabel": "Scan to download the app.",
  "download.qrAlt": "QR code to download the Flourish app",
  "download.modal.close": "Close dialog",
  "appPromo.eyebrow": "Optimised mobile app",
  "appPromo.title": "Get the Flourish app",
  "appPromo.body": "This experience lives in the app. Download it to explore the map, save favorites, and follow activity.",
  "appPromo.homeLink": "Continue to the website",
  "web.nav.home": "Home",
  "web.nav.map": "Map",
  "web.nav.houses": "Champagne houses",
  "web.nav.experiences": "Experiences",
  "web.nav.guides": "Guides",
  "web.map.locate": "Focus on my location",
  "web.map.eyebrow": "Live map",
  "web.map.title": "Explore Champagne on the web",
  "web.map.subtitle": "Browse Champagne houses, landmarks, and touristic routes on a desktop-friendly map.",
  "web.map.empty": "No locations to show yet. Adjust your filters to see more.",
  "web.map.save": "Save",
  "web.map.saved": "Saved",
  "web.map.list": "List",
  "web.favorites.subtitle": "Your saved Champagne houses and landmarks, ready for your next trip.",
  "web.activity.subtitle": "Follow tastings and visits shared by the community.",
  "web.activity.loadMore": "Load more",
  "web.activity.loadingMore": "Loading…",
  "web.profile.subtitle": "Log in or create an account to sync your favorites.",
  "web.profile.verified": "Email verified",
  "web.profile.unverified": "Email not verified",
  "web.profile.verify.title": "Verify your email",
  "web.profile.verify.body": "Enter the 6-digit code we sent to {{ email }}.",
  "web.profile.verify.label": "Verification code",
  "web.profile.verify.placeholder": "6-digit code",
  "web.profile.verify.send": "Resend code",
  "web.profile.verify.sending": "Resending…",
  "web.profile.verify.submit": "Verify email",
  "web.profile.verify.verifying": "Verifying…",
  "web.profile.verify.validation": "Enter the 6-digit code.",
  "web.profile.verify.sent": "Verification code sent.",
  "web.profile.verify.success": "Email verified. Thanks!",
  "web.profile.verify.error": "Unable to verify your email. Please try again.",
  "web.profile.verify.sendError": "Unable to send a verification code. Please try again.",
  "web.profile.session.title": "Session",
  "web.profile.session.body": "Sign out to switch accounts or reset your session.",
  "web.profile.loading": "Loading…",
  "web.profile.account.edit": "Edit",
  "web.profile.account.close": "Close",
  "web.profile.accountOptions.title": "Account options",
  "web.profile.accountOptions.description": "Delete your account.",
  "seo.site.name": "Flourish",
  "seo.home.title": "Discover Champagne With Flourish",
  "seo.home.description": "Plan a Champagne escape with curated routes, storied houses, and landmark stops — all in one elegant guide.",
  "seo.map.title": "Champagne Map & Routes",
  "seo.map.description": "Explore Champagne houses, landmarks, and touring routes on an interactive map built for planning.",
  "seo.houses.title": "Champagne Houses",
  "seo.houses.description": "Browse verified Champagne houses on Flourish, discover the featured house of the day, and explore wines, visits, and stories across the region.",
  "seo.getApp.title": "Get the Flourish App",
  "seo.getApp.description": "Download Flourish to save favorites, follow the Route Touristique, and carry the Champagne guide with you.",
  "seo.experiences.title": "Champagne Experiences",
  "seo.experiences.description": "Browse verified Champagne experiences from partner houses and plan your next tasting, visit, or cellar moment.",
  "seo.guides.title": "Champagne Travel Guides",
  "seo.guides.description": "Plan Champagne houses, tastings, villages, itineraries, routes, and first-time experiences with curated Flourish guides.",
  "seo.favorites.title": "Your Champagne Favorites",
  "seo.favorites.description": "Keep a shortlist of Champagne houses and landmarks for your next visit.",
  "seo.activity.title": "Community Tastings & Visits",
  "seo.activity.description": "Follow tastings and visits shared by the Flourish community.",
  "seo.profile.title": "Your Flourish Profile",
  "seo.profile.description": "Manage your account, sync favorites, and verify your email.",
  "seo.winery.description": "Discover {{ name }} in Champagne. Find tasting details, contact info, and directions.",
  "seo.wine.description": "Discover {{ wine }} from {{ winery }} and plan your tasting.",
  "seo.landmark.description": "Discover {{ name }} in Champagne and plan your visit with Flourish.",
  "tabs.map": "Map",
  "tabs.nearby": "Nearby",
  "tabs.favorites": "Favorites",
  "tabs.activity": "Activity",
  "tabs.profile": "Profile",
  "activity.title": "Activity",
  "activity.loading": "Loading activity…",
  "activity.empty.title": "No activity yet",
  "activity.empty.description": "Tastings from you and your friends will show up here.",
  "activity.items.tasting": "Tasting",
  "activity.items.wineryVisit": "Champagne house visit",
  "activity.items.landmarkVisit": "Landmark visit",
  "activity.errors.load": "Unable to load activity right now.",
  "activity.loginPrompt.title": "Log in to see activity",
  "activity.loginPrompt.description": "Sign in to view tastings from you and your friends.",
  "activity.loginPrompt.button": "Go to login",
  "nearby.title": "Nearby",
  "nearby.loading": "Finding places near you...",
  "nearby.empty.title": "No places nearby yet",
  "nearby.empty.description": "Enable location services to see Champagne houses and landmarks closest to you.",
  "nearby.distance": "{{ distance }} km",
  "nearby.locationFallback": "We couldn't access your location. Distances are shown from the Champagne region.",
  "nearby.errors.load": "Unable to load nearby places.",
  "nearby.filter.title": "Filter by category",
  "nearby.filter.all": "All",
  "nearby.filter.wineries": "Champagne houses",
  "nearby.filter.showFavorites": "Show favorites only",
  "nearby.filter.categories": "Categories",
  "nearby.filter.filter": "Filter",
  "nearby.sort.label": "Sort",
  "nearby.sort.distance": "Distance",
  "nearby.sort.alpha": "Alphabetical",
  "nearby.filter.reset": "Reset",
  "nearby.filter.apply": "Apply",
  "map.title": "Map",
  "map.marker.youAreHere": "You are here",
  "map.marker.showMore": "Show more",
  "map.marker.openPage": "Open page",
  "map.marker.wineryLabel": "Champagne houses",
  "map.list.comingSoon.title": "Coming soon",
  "map.list.comingSoon.body": "We're working on Champagne houses and plan to launch in a few weeks.",
  "map.marker.routeLabel": "Touristic route",
  "map.marker.routeDownloadCta": "Download the app to follow this route",
  "map.marker.toggleFavorite": "Toggle favorite",
  "map.detail.loading": "Loading details...",
  "map.detail.error": "Unable to load details.",
  "map.detail.close": "Close",
  "map.detail.backToMap": "Back to map",
  "map.detail.wineryLabel": "Champagne house",
  "map.detail.verifiedProfile": "Verified winery",
  "map.detail.wineLabel": "Champagne",
  "map.detail.wine.from": "Champagne house",
  "map.detail.wine.backToWinery": "Back to house",
  "map.detail.wine.specs": "Technical details",
  "map.detail.wine.dosage": "Dosage",
  "map.detail.wine.assemblage": "Assemblage",
  "map.detail.section.houseHistory": "House history",
  "map.detail.section.tastingExperience": "Tasting experience",
  "map.detail.section.description": "Description",
  "map.detail.section.experiences": "Experiences",
  "experiences.page.eyebrow": "Verified experiences",
  "houses.page.eyebrow": "Champagne houses",
  "houses.page.title": "Discover the houses shaping your next Champagne escape.",
  "houses.page.body": "Browse a growing collection of Champagne houses on Flourish, from established names to more intimate addresses worth planning around.",
  "houses.page.signals.curated.title": "Curated for discovery",
  "houses.page.signals.curated.body": "Every profile is presented as a destination worth opening, not just a pin in a directory.",
  "houses.page.signals.verified.title": "Verified profiles",
  "houses.page.signals.verified.body": "The houses featured here are public, verified, and ready to be explored on Flourish.",
  "houses.page.signals.planning.title": "Built for planning",
  "houses.page.signals.planning.body": "Move from inspiration to a concrete house page, map view, or tasting idea without leaving the platform.",
  "houses.page.featured.eyebrow": "Featured house of the day",
  "houses.page.actions.open": "Open",
  "houses.page.actions.viewHouse": "View house",
  "houses.page.actions.openMap": "Open on map",
  "houses.page.filters.search": "Search",
  "houses.page.filters.searchPlaceholder": "Search by house name",
  "houses.page.filters.city": "City",
  "houses.page.filters.allCities": "All cities",
  "houses.page.filters.hasExperiences": "Has experiences",
  "houses.page.filters.hasWines": "Has wines",
  "houses.page.filters.favorites": "Favorites only",
  "houses.page.filters.sort": "Sort",
  "houses.page.filters.clear": "Clear filters",
  "houses.page.sort.alphabetical": "A to Z",
  "houses.page.sort.recent": "Recently updated",
  "houses.page.collection.eyebrow": "Explore the collection",
  "houses.page.collection.title": "Champagne houses to keep exploring",
  "houses.page.card.fallback": "Open the full house page to discover its story, wines, and visitor details.",
  "houses.page.meta.experience.one": "{{ count }} experience",
  "houses.page.meta.experience.other": "{{ count }} experiences",
  "houses.page.meta.experience.from.one": "{{ count }} experience from {{ price }}",
  "houses.page.meta.experience.from.other": "{{ count }} experiences from {{ price }}",
  "houses.page.meta.wine.one": "{{ count }} cuvee",
  "houses.page.meta.wine.other": "{{ count }} cuvees",
  "houses.page.empty.eyebrow": "No exact match",
  "houses.page.empty.title": "No houses match these filters yet",
  "houses.page.empty.body": "Reset the filters or jump to the map to continue exploring Champagne from another angle.",
  "houses.page.empty.cta": "Explore the map",
  "houses.page.footer.eyebrow": "Keep exploring",
  "houses.page.footer.title": "Switch perspective whenever you want.",
  "houses.page.footer.body": "Use the map to browse geographically or head to experiences to focus on tastings and visits already open for discovery.",
  "houses.page.footer.mapCta": "Open the map",
  "houses.page.footer.experiencesCta": "See experiences",
  "experiences.page.title": "Book the most memorable experiences in Champagne.",
  "experiences.page.body": "A growing collection of tastings, cellar visits, and house-led moments from verified Champagne wineries, gathered in one place.",
  "experiences.page.stats.experiences": "Experiences",
  "experiences.page.stats.houses": "Champagne houses",
  "experiences.page.highlights.curated.title": "Curated carefully",
  "experiences.page.highlights.curated.body": "Every listing comes from a verified Champagne house already featured on Flourish.",
  "experiences.page.highlights.booking.title": "Built for planning",
  "experiences.page.highlights.booking.body": "See pricing, duration, and the exact house behind each experience before you commit.",
  "experiences.page.highlights.local.title": "More coming soon",
  "experiences.page.highlights.local.body": "The catalog is still young, so each new experience is given room to shine instead of getting lost in a crowded grid.",
  "experiences.page.collection.eyebrow": "More to discover",
  "experiences.page.collection.title": "Continue exploring the collection",
  "experiences.page.singleNote": "More verified experiences will appear here as additional Champagne houses publish their offerings.",
  "experiences.page.empty.title": "Experiences are on the way",
  "experiences.page.empty.body": "Our winery partners are preparing their first public experiences. Check back soon or explore the Champagne map in the meantime.",
  "experiences.page.empty.cta": "Explore the map",
  "map.detail.section.contact": "Contact",
  "map.detail.section.wines": "Signature wines",
  "map.detail.field.address": "Address",
  "map.detail.field.email": "Email",
  "map.detail.field.website": "Website",
  "map.detail.field.phone": "Phone",
  "map.detail.action.openWebsite": "Open",
  "map.detail.action.call": "Call",
  "map.detail.action.email": "Email",
  "map.detail.action.navigate": "Navigate",
  "map.detail.action.appleMaps": "Apple Maps",
  "map.detail.action.googleMaps": "Google Maps",
  "map.detail.wines.empty": "No wines available yet.",
  "map.detail.wines.noDescription": "No description yet.",
  "map.detail.experiences.noDescription": "More details coming soon.",
  "map.detail.experiences.checkAvailability": "Check availability",
  "map.detail.experiences.availableNow": "Available now",
  "map.detail.experiences.from": "From",
  "experience.detail.availability.loading": "Loading availability...",
  "experience.detail.availability.loadError": "Unable to load availability right now.",
  "experience.detail.duration": "Duration",
  "experience.detail.gallery.open": "Click to see full view",
  "experience.detail.gallery.modal": "Experience image gallery",
  "experience.detail.gallery.close": "Close image gallery",
  "experience.detail.gallery.previous": "Previous image",
  "experience.detail.gallery.next": "Next image",
  "experience.detail.gallery.thumbnail": "Open image {{index}}",
  "experience.detail.gallery.counter": "Image {{current}} of {{total}}",
  "experience.detail.section.practicalInfo": "Practical info",
  "experience.detail.section.includedExcluded": "Included and excluded",
  "experience.detail.section.location": "Location",
  "experience.detail.section.price": "Price",
  "experience.detail.practicalInfo.knowBeforeYouGo": "Know before you go",
  "experience.detail.practicalInfo.requirements": "Requirements",
  "experience.detail.practicalInfo.location": "Location",
  "experience.detail.includedExcluded.included": "Included",
  "experience.detail.includedExcluded.excluded": "Excluded",
  "experience.detail.price.adult": "Adult",
  "experience.detail.price.child": "Child",
  "experience.detail.availability.timeslots": "Available timeslots",
  "experience.detail.availability.noFutureAvailabilityTitle": "No available timeslots",
  "experience.detail.availability.book": "Book",
  "experience.detail.availability.noSlots": "Select a date with availability to see the available timeslots.",
  "experience.detail.availability.noFutureAvailability": "There are currently no upcoming dates available for this experience.",
  "experience.detail.availability.unlimited": "Tickets available",
  "experience.detail.availability.ticketsLeft": "{{count}} tickets left",
  "experience.booking.modal.close": "Close booking dialog",
  "experience.booking.step.selection": "Selection",
  "experience.booking.step.details": "Details",
  "experience.booking.step.payment": "Payment",
  "experience.booking.step.confirmation": "Confirmation",
  "experience.booking.stepCounter": "Step {{current}} of {{total}}",
  "experience.booking.summary.date": "Date",
  "experience.booking.summary.startHour": "Start hour",
  "experience.booking.summary.endHour": "End hour",
  "experience.booking.summary.from": "From",
  "experience.booking.summary.until": "until",
  "experience.booking.summary.price": "Price",
  "experience.booking.summary.guestSingular": "guest",
  "experience.booking.summary.guestPlural": "guests",
  "experience.booking.selection.title": "Choose your guests",
  "experience.booking.selection.subtitle": "Select the number of adults and children joining this experience.",
  "experience.booking.selection.total": "Total price",
  "experience.booking.selection.decreaseAdult": "Decrease adults",
  "experience.booking.selection.increaseAdult": "Increase adults",
  "experience.booking.selection.decreaseChild": "Decrease children",
  "experience.booking.selection.increaseChild": "Increase children",
  "experience.booking.details.title": "Provide your details",
  "experience.booking.details.subtitle": "Enter the contact details for this booking.",
  "experience.booking.details.firstName": "First name",
  "experience.booking.details.lastName": "Last name",
  "experience.booking.details.email": "Email address",
  "experience.booking.details.phone": "Phone number",
  "experience.booking.details.error": "Please complete all fields and enter a valid email address.",
  "experience.booking.payment.title": "Payment",
  "experience.booking.payment.subtitle": "Pay securely to complete this booking.",
  "experience.booking.payment.loading": "Preparing secure payment...",
  "experience.booking.payment.fallback": "Or continue with card or Bancontact",
  "experience.booking.payment.note": "Depending on the payment method, you may be briefly redirected to authorize the payment. Once it succeeds, we will finalize the booking and send your confirmation email.",
  "experience.booking.payment.error": "We could not complete your booking. Please try again.",
  "experience.booking.payment.returnError": "We could not confirm your payment after returning. Please try again.",
  "experience.booking.confirmation.subtitle": "Review the booking confirmation.",
  "experience.booking.confirmation.title": "Booking confirmation",
  "experience.booking.confirmation.message": "Your booking was successful. A confirmation email will be sent soon.",
  "experience.booking.closeConfirm.title": "Close booking?",
  "experience.booking.closeConfirm.message": "Are you sure you want to close this booking flow? Your current progress will be lost.",
  "experience.booking.closeConfirm.confirm": "Close booking",
  "experience.booking.closeConfirm.cancel": "Keep booking",
  "experience.booking.actions.back": "Back",
  "experience.booking.actions.next": "Next",
  "experience.booking.actions.confirm": "Confirm booking",
  "experience.booking.actions.pay": "Pay now",
  "experience.booking.actions.processing": "Processing...",
  "experience.booking.actions.close": "Close",
  "map.detail.wines.unshared": "This champagne house is not sharing its champagnes with us yet.",
  "map.detail.wines.grapes": "grapes",
  "map.legend.title": "Legend",
  "map.legend.landmarksTitle": "Landmarks",
  "map.loading.google": "Loading map…",
  "map.loading.wineries": "Loading Champagne houses…",
  "map.loading.places": "Loading places…",
  "map.touristicRoutes.title": "Touristic routes",
  "map.touristicRoutes.names.montagneDeReims": "Montagne de Reims",
  "map.touristicRoutes.names.valleeDeLaMarne": "Marne Valley",
  "map.touristicRoutes.names.coteDesBlancs": "Côte des Blancs",
  "map.touristicRoutes.names.coteauxVitryats": "Coteaux Vitryats",
  "map.touristicRoutes.names.coteauxSezannais": "Sézannais Hills",
  "map.touristicRoutes.names.coteDesBar": "Côte des Bar",
  "map.touristicRoutes.background.montagneDeReims": "A scenic loop through forested hills and iconic Champagne villages in the Montagne de Reims area.",
  "map.touristicRoutes.background.valleeDeLaMarne": "Follow the Marne Valley, where vineyards line the river and charming towns punctuate the route.",
  "map.touristicRoutes.background.coteDesBlancs": "Discover the chalky slopes of the Côte des Blancs, the heartland of Chardonnay in Champagne.",
  "map.touristicRoutes.background.coteauxVitryats": "A quieter itinerary around the Coteaux Vitryats, with open landscapes and a more off-the-beaten-path feel.",
  "map.touristicRoutes.background.coteauxSezannais": "Explore the rolling Sézannais hills, a mosaic of vineyards and countryside villages.",
  "map.touristicRoutes.background.coteDesBar": "Head south to the Côte des Bar, known for its Pinot Noir vineyards and broader, rural landscapes.",
  "map.errors.googleLoad": "Unable to load the map right now. Please try again later.",
  "map.errors.wineries": "We could not load the Champagne house list.",
  "map.errors.landmarks": "We could not load the landmark list.",
  "map.errors.routes": "Unable to load touristic routes.",
  "map.controls.location": "Center on my location",
  "favorites.errors.loginRequired": "Please log in to manage favorites.",
  "favorites.errors.update": "Unable to update favorites right now.",
  "favorites.title": "Favorites",
  "favorites.empty.title": "No favorites yet",
  "favorites.empty.description": "Tap the heart icon on a Champagne house or landmark to save it here.",
  "favorites.empty.wineriesTitle": "No Champagne houses yet",
  "favorites.empty.wineriesDescription": "Discover the map and tap the heart to save a Champagne house.",
  "favorites.empty.landmarksTitle": "No landmarks saved",
  "favorites.empty.landmarksDescription": "Add landmarks to your favorites to find them faster.",
  "favorites.loginPrompt.title": "Log in to save favorites",
  "favorites.loginPrompt.description": "Create an account to keep track of your favorite Champagne houses.",
  "favorites.loginPrompt.button": "Go to login",
  "favorites.list.add": "Add to favorites",
  "favorites.list.marked": "Marked as favorite",
  "favorites.list.remove": "Remove favorite",
  "favorites.confirmRemove": "Remove this favorite?",
  "favorites.confirmRemoveConfirm": "Remove",
  "favorites.confirmRemoveCancel": "Cancel",
  "favorites.segment.all": "All",
  "favorites.segment.wineries": "Champagne houses",
  "favorites.segment.wineriesShort": "Houses",
  "favorites.segment.landmarks": "Landmarks",
  "favorites.tabs.all": "All",
  "favorites.tabs.landmarks": "Landmarks",
  "favorites.errors.refresh": "Unable to refresh favorites.",
  "profile.title": "Profile",
  "profile.logout": "Log out",
  "profile.favorites.button": "View favorites",
  "profile.login.title": "Log in",
  "profile.login.labels.email": "Email",
  "profile.login.labels.password": "Password",
  "profile.login.placeholders.email": "you@example.com",
  "profile.login.placeholders.password": "Enter your password",
  "profile.login.validation.email": "Enter a valid email address.",
  "profile.login.validation.password": "Password is required.",
  "profile.login.submit": "Log in",
  "profile.login.switch": "Don't have an account? Register",
  "profile.login.error": "Unable to log in. Please check your credentials.",
  "profile.register.title": "Register",
  "profile.register.labels.name": "Username",
  "profile.register.labels.email": "Email",
  "profile.register.labels.password": "Password",
  "profile.register.labels.confirmPassword": "Confirm password",
  "profile.register.placeholders.name": "Your username",
  "profile.register.placeholders.email": "you@example.com",
  "profile.register.placeholders.password": "Create a password",
  "profile.register.placeholders.confirmPassword": "Re-enter password",
  "profile.register.validation.name": "Please enter a username (min. 2 characters, no spaces).",
  "profile.register.validation.email": "Enter a valid email address.",
  "profile.register.validation.password": "Password must be at least 8 characters long.",
  "profile.register.validation.confirmPassword": "Passwords must match.",
  "profile.register.submit": "Create account",
  "profile.register.switch": "Already have an account? Log in",
  "profile.register.error": "Unable to register. Please try again later.",
  "profile.register.error.usernameTaken": "This username is already taken.",
  "profile.register.error.emailTaken": "An account with this email already exists.",
  "profile.account.settings.title": "Account",
  "profile.account.settings.description": "Manage your profile details and privacy.",
  "profile.account.settings.username": "Username",
  "profile.account.settings.usernameDescription": "Update your username.",
  "profile.account.settings.avatar": "Profile picture",
  "profile.account.settings.avatarDescription": "Upload or change the photo shown on your profile.",
  "profile.account.settings.email": "Email address",
  "profile.account.settings.emailDescription": "Change your login email and manage verification.",
  "profile.account.settings.password": "Password",
  "profile.account.settings.passwordDescription": "Change the password you use to sign in.",
  "profile.account.settings.dangerZone": "Danger zone",
  "profile.account.settings.deletionDescription": "Request to remove your account permanently.",
  "profile.account.avatar.headline": "Set your profile picture",
  "profile.account.avatar.description": "Upload a photo to personalize your account.",
  "profile.account.avatar.hint": "Use a clear square image, up to 8 MB.",
  "profile.account.avatar.select": "Choose an image",
  "profile.account.avatar.remove": "Remove profile picture",
  "profile.account.avatar.noFile": "Select an image before uploading.",
  "profile.account.avatar.invalidType": "Please choose an image file.",
  "profile.account.avatar.fileTooLarge": "Image is too large (max 8 MB).",
  "profile.account.avatar.uploadFailed": "We couldn't upload this image. Try another file.",
  "profile.account.avatar.success": "Profile picture updated successfully.",
  "profile.account.avatar.removed": "Profile picture removed.",
  "profile.account.avatar.error": "Unable to update profile picture right now.",
  "profile.account.labels.name": "Username",
  "profile.account.labels.email": "Email",
  "profile.account.placeholders.name": "Your username",
  "profile.account.placeholders.email": "you@example.com",
  "profile.account.validation.name": "Please enter a username (min. 2 characters, no spaces).",
  "profile.account.validation.email": "Enter a valid email address.",
  "profile.account.submit": "Save changes",
  "profile.account.success": "Account updated successfully.",
  "profile.account.error": "Unable to update account right now.",
  "profile.accountDeletion.cardTitle": "Delete my account",
  "profile.accountDeletion.description": "Request deletion of your account and data. You'll confirm with your password and a 6-digit email code.",
  "profile.accountDeletion.passwordPlaceholder": "Current password",
  "profile.accountDeletion.passwordRequired": "Please enter your password to confirm.",
  "profile.accountDeletion.requestCodeButton": "Send code",
  "profile.accountDeletion.codeTitle": "Enter confirmation code",
  "profile.accountDeletion.codePlaceholder": "123456",
  "profile.accountDeletion.codeRequired": "Enter the 6-digit code from your email.",
  "profile.accountDeletion.codeSent": "A confirmation code was sent to your email.",
  "profile.accountDeletion.codeError": "Unable to send the confirmation code right now.",
  "profile.accountDeletion.confirmButton": "Delete account",
  "profile.accountDeletion.cancel": "Keep my account",
  "profile.accountDeletion.success": "Your account was deleted. We're sorry to see you go.",
  "profile.accountDeletion.error": "Unable to delete your account right now.",
  "profile.password.labels.current": "Current password",
  "profile.password.labels.new": "New password",
  "profile.password.labels.confirm": "Confirm new password",
  "profile.password.placeholders.current": "Enter current password",
  "profile.password.placeholders.new": "Enter new password",
  "profile.password.placeholders.confirm": "Re-enter new password",
  "profile.password.validation.current": "Please enter your current password.",
  "profile.password.validation.length": "Password must be at least 8 characters.",
  "profile.password.validation.confirm": "Please confirm your new password.",
  "profile.password.error.mismatch": "New passwords do not match.",
  "profile.password.error.generic": "Unable to update password right now.",
  "profile.password.success": "Password updated successfully.",
  "profile.password.submit": "Update password",
  "profile.usernameAvailability.checking": "Checking username availability...",
  "profile.usernameAvailability.available": "Username is available.",
  "profile.usernameAvailability.unavailable": "Username is not available.",
  "profile.usernameAvailability.error": "Unable to check username right now.",
  "landmarks.categories.museum": "Museum",
  "landmarks.categories.historical": "Historical site",
  "landmarks.categories.viewpoint": "Viewpoint",
  "landmarks.categories.attraction": "Attraction"
}
